// Static CSS using CSS variables, injected into Shadow DOM
export const BASE_CSS = `
  :host {
    all: initial;
    position: fixed !important;
    inset: 0 !important;
    z-index: 2147483647 !important;
    pointer-events: none !important;
    font-family: var(--font, Inter), -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
    font-size: var(--font-size, 14px);
    color: var(--text, #1f2937);
    line-height: 1.4;
  }

  .puw2-container { position: fixed; z-index: var(--z-index, 2147483647); pointer-events: auto; }

  /* Position utilities populated inline via style */

  /* Button */
  .puw2-button {
    width: 56px; height: 56px; border-radius: var(--radius, 8px);
    border: none; cursor: pointer; display: flex; align-items: center; justify-content: center;
    box-shadow: 0 var(--shadow-btn-y, 4px) var(--shadow-btn-blur, 12px) rgba(0,0,0,var(--shadow-btn-alpha,0.18));
    transition: transform .3s ease, box-shadow .3s ease; overflow: hidden;
    background: var(--bg-button, var(--primary, #2563eb)); color: #fff;
  }
  .puw2-button:hover { transform: scale(1.05); }
  .puw2-button svg { width: 28px; height: 28px; stroke: currentColor; fill: none; stroke-width: 2; }
  .puw2-button svg.puw2-pingup path { fill: var(--on-primary,#fff); }

  /* Mascotte 3D al posto della bolla (theme.buttonStyle = "mascotte3d") */
  .puw2-mascotte {
    display: block; width: 72px; height: 72px; padding: 0; border: 0; background: transparent; cursor: pointer;
    filter: drop-shadow(0 4px 8px rgba(0,0,0,.18)); transition: transform .3s ease;
  }
  .puw2-mascotte:hover { transform: scale(1.05); }
  .puw2-mascotte:focus-visible { outline: 2px solid var(--primary, #2563eb); outline-offset: 2px; border-radius: 12px; }
  .puw2-mascotte canvas { display: block; width: 100%; height: 100%; }
  /* la mascotte resta nell'angolo anche a chat aperta: la finestra si apre sopra di lei */
  .puw2-con-mascotte .puw2-chat {
    position: absolute; bottom: calc(100% + 12px);
    max-height: calc(100dvh - 72px - 12px - 32px);
  }
  .puw2-con-mascotte.lato-destra .puw2-chat { right: 0; }
  .puw2-con-mascotte.lato-sinistra .puw2-chat { left: 0; transform-origin: bottom left; }

  /* Chat window */
  .puw2-chat {
    width: var(--chat-width, 360px); height: var(--chat-height, min(85vh, calc(100dvh - 96px))); background: var(--bg, #fff);
    border-radius: var(--radius, 8px); box-shadow: 0 var(--shadow-chat-y, 8px) var(--shadow-chat-blur, 24px) rgba(0,0,0,var(--shadow-chat-alpha,0.15));
    display: none; flex-direction: column; overflow: hidden; transform-origin: bottom right; overscroll-behavior-x: none;
  }

  .puw2-text p {margin: 0;}

  /* Animations (ported from V1) */
  @keyframes puw2FadeIn { from { opacity: 0; transform: scale(.8);} to{opacity:1; transform: scale(1);} }
  @keyframes puw2FadeOut { from { opacity: 1; transform: scale(1);} to{opacity:0; transform: scale(.8);} }
  @keyframes puw2SlideIn { from{transform: translateY(20px); opacity:0;} to{transform: translateY(0); opacity:1;} }
  @keyframes puw2SlideOut { from{transform: translateY(0); opacity:1;} to{transform: translateY(20px); opacity:0;} }
  @keyframes puw2BalloonIn { 0%{opacity:0; transform:scale(.2);}60%{opacity:1; transform:scale(1.03);}100%{transform:scale(1);} }
  @keyframes puw2BalloonOut { 0%{opacity:1; transform:scale(1);}40%{opacity:.7; transform:scale(1.03);}100%{opacity:0; transform:scale(.2);} }

  .anim-fade-in { animation: puw2FadeIn .3s ease-out; }
  .anim-fade-out { animation: puw2FadeOut .3s ease-in forwards; }
  .anim-slide-in { animation: puw2SlideIn .3s ease-out; }
  .anim-slide-out { animation: puw2SlideOut .3s ease-in forwards; }
  .anim-balloon-in { animation: puw2BalloonIn .4s cubic-bezier(0.34, 1.30, 0.64, 1); }
  .anim-balloon-out { animation: puw2BalloonOut .4s cubic-bezier(0.5, 0, 0.75, 0) forwards; }

  .puw2-header { padding: var(--spacing,16px); background: var(--header-bg, var(--primary,#2563eb)); color: var(--on-primary,#fff); display: flex; align-items:center; justify-content: space-between; gap: 8px; }
  .puw2-header h3 { margin: 0; font-size: 16px; font-weight: 600; }
  .puw2-header p { margin: 2px 0 0 0; font-size: 12px; opacity: .85; }
  .puw2-control { width:28px; height:28px; border:none; background: var(--on-primary-soft, rgba(255,255,255,.12)); color: var(--on-primary,#fff); border-radius:4px; cursor:pointer; display:flex; align-items:center; justify-content:center; }
  .puw2-control:hover{ background: var(--on-primary-soft-hover, rgba(255,255,255,.2)); }
  .puw2-control svg { width:18px; height:18px; stroke: currentColor; fill: none; display: block; }

  .puw2-messages { flex:1; padding: var(--spacing,16px); overflow-y:auto; overflow-x:hidden; display:flex; flex-direction:column; gap:12px; overscroll-behavior: contain; scroll-behavior: smooth; }
  .puw2-msg { display:flex; gap:8px; align-items:flex-start; }
  .puw2-msg.user { flex-direction: row-reverse; }
  .puw2-msg.bot { align-items: stretch; flex-direction: column; }
  .puw2-bubble { width:fit-content; max-width:80%; border-radius:18px; word-wrap: break-word; overflow: hidden; }
  .puw2-msg.bot .puw2-bubble { background: var(--bot-bubble-bg, #f3f4f6); color: var(--bot-bubble-text, var(--text,#1f2937)); border-bottom-left-radius:4px; }
  .puw2-msg.user .puw2-bubble { background: var(--primary,#2563eb); color:#fff; border-bottom-right-radius:4px; max-width:80%; }
  
  /* Bubble content with padding */
  .puw2-text { padding: 12px 16px; padding-bottom:0px; }
  /* I link nelle risposte si devono vedere: grassetto, sottolineati, e nei
     messaggi del bot col colore dei link (--link, calcolato in ChatApp per
     leggersi sul fumetto). Nei messaggi dell'utente restano del colore del
     testo, sopra il colore del marchio. */
  .puw2-text a { color: inherit; font-weight: 600; text-decoration: underline; text-decoration-thickness: 1px; text-underline-offset: 2px; word-break: break-word; }
  .puw2-msg.bot .puw2-text a { color: var(--link, #1d4ed8); }
  .puw2-text a:hover { text-decoration-thickness: 2px; }
  .puw2-time { font-size: 8px; opacity: .7; padding: 0 16px 8px 16px; text-align: right; }
  
  /* Bubble footer for products toggle - integrated seamlessly with primary color */
  .puw2-bubble-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    background: color-mix(in srgb, var(--primary, #2563eb) 8%, transparent);
  }
  
  .puw2-products-toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 10px 16px;
    background: transparent;
    border: none;
    color: var(--primary, #2563eb);
    font-size: calc(var(--font-size, 14px) - 1px);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  
  .puw2-products-toggle:hover {
    background: color-mix(in srgb, var(--primary, #2563eb) 12%, transparent);
  }
  
  .puw2-products-toggle:active {
    background: color-mix(in srgb, var(--primary, #2563eb) 15%, transparent);
  }
  
  .puw2-products-icon {
    width: 16px;
    height: 16px;
    stroke: currentColor;
    fill: none;
    stroke-width: 2;
    flex-shrink: 0;
  }
  
  .puw2-products-text {
    flex: 1;
    text-align: left;
  }
  
  .puw2-products-chevron {
    width: 14px;
    height: 14px;
    stroke: currentColor;
    fill: none;
    stroke-width: 2.5;
    transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    opacity: 0.6;
    flex-shrink: 0;
  }
  
  .puw2-products-chevron.rotated {
    transform: rotate(180deg);
  }
  
  /* Product cards appear below the bubble */
  .puw2-cards { 
    margin-top: 8px; 
    overflow: hidden; 
    width: 100%; 
    position: relative;
  }
  
  .puw2-cards.expanded {
    animation: cardsSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  
  @keyframes cardsSlideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Navigation arrows for cards - subtle and elegant */
  .puw2-card-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.2s ease;
    color: #6b7280;
    opacity: 0;
    pointer-events: none;
  }

  .puw2-cards:hover .puw2-card-nav {
    opacity: 1;
    pointer-events: all;
  }

  .puw2-card-nav:hover {
    background: rgba(255, 255, 255, 0.95);
    color: var(--primary, #2563eb);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    transform: translateY(-50%) scale(1.05);
  }

  .puw2-card-nav:active {
    transform: translateY(-50%) scale(0.98);
  }

  .puw2-card-nav svg {
    width: 16px;
    height: 16px;
  }

  .puw2-card-nav-left {
    left: 4px;
  }

  .puw2-card-nav-right {
    right: 4px;
  }

  /* Hide arrows on mobile - touch is easier */
  @media (max-width: 768px) {
    .puw2-card-nav {
      display: none;
    }
  }

  .puw2-input-area { padding: var(--spacing,16px); border-top: 1px solid #e5e7eb; background: var(--bg,#fff); }
  .puw2-input-wrap { display:flex; gap:8px; align-items:center; min-height: 40px; }
  .puw2-input { flex:1; resize:none; height: 100%; border:1px solid #e5e7eb; border-radius: var(--radius,8px); padding:8px 10px; font: inherit; }
  .puw2-send { width:40px; height:40px; border-radius: var(--radius,8px); border:none; background: var(--primary,#2563eb); color:#fff; display:flex; align-items:center; justify-content:center; cursor:pointer; opacity: .9; }
  .puw2-send svg {
        width: 18px;
        height: 18px;
      }
  .puw2-send:disabled { opacity:.4; cursor:not-allowed; }

  .puw2-quick-replies { display:none; gap:8px; flex-wrap: wrap; padding: 0 var(--spacing,16px) 8px var(--spacing,16px); }
  .puw2-quick-replies.visible { display:flex; }
  .puw2-chip { border:1px solid var(--primary,#2563eb); background: transparent; color: var(--primary,#2563eb); border-radius: calc(var(--radius,8px) * 2); padding: 8px 16px; cursor:pointer; transition: background .2s ease, color .2s ease; box-shadow: 0 2px 8px rgba(0,0,0,.1); font-size: var(--font-size,12px); font-family: inherit; }
  .puw2-chip:hover { background: var(--primary,#2563eb); color: #fff; }

  .puw2-typing { display:flex; gap:4px; padding: 8px 12px; }
  .puw2-dot { width:6px; height:6px; border-radius:50%; background: var(--secondary,#64748b); opacity:.3; animation: puw2Dots 1.2s infinite; }
  .puw2-dot:nth-child(2){ animation-delay: .2s }
  .puw2-dot:nth-child(3){ animation-delay: .4s }
  @keyframes puw2Dots { 0%,60%,100%{opacity:.3} 30%{opacity:1} }

  /* Mobile fullscreen - simplified without problematic CSS variables */
  @media (max-width: 768px) {
    /* la chat occupa tutto lo schermo: la mascotte si nasconde finche' resta aperta
       e la chat non tiene conto dello spazio della mascotte */
    .puw2-mascotte.is-aperta { display: none; }
    .puw2-con-mascotte .puw2-chat { max-height: none !important; }

    .puw2-chat {
      position: fixed !important; 
      top: 0 !important; 
      left: 0 !important; 
      right: 0 !important; 
      bottom: 0 !important;
      width: 100vw !important; 
      height: 100vh !important;
      height: 100dvh !important;
      border-radius: 0 !important; 
      transform-origin: center;
      z-index: 2147483647 !important;
    }
    
    .puw2-input { 
      font-size: 16px; /* prevent iOS zoom on focus */
    }
    
    .puw2-messages { 
      overscroll-behavior: none; 
      -webkit-overflow-scrolling: touch;
      scroll-behavior: auto;
    }
    
    /* Prevent body scroll when widget is active */
    body.pingup-widget-mobile-active {
      overflow: hidden !important;
    }
    .puw2-input-area { 
      position: relative; 
      background: var(--bg,#fff);
    }
  }

  .puw2-card-row {  
    display: flex;
    gap: 12px;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 4px;
    width: 100%;
    max-width: 100%;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
    scroll-snap-type: x proximity;
  }
  
  .puw2-card-row::-webkit-scrollbar { display: none; }
  .rag-mini-card { scroll-snap-align: start; }

  /* Modern minimal card design */
  .rag-mini-card { 
    flex-shrink: 0; 
    width: 200px; 
    background: var(--bg,#fff); 
    border: 1px solid #f1f3f5; 
    border-radius: 12px; 
    overflow: hidden; 
    box-shadow: 0 1px 3px rgba(0,0,0,.04); 
    display: flex; 
    flex-direction: column; 
    transition: all .3s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateY(20px);
    opacity: 0;
    text-decoration: none;
    color: inherit;
  }

  .rag-mini-card-link {
    cursor: pointer;
  }

  .rag-mini-card-disabled {
    cursor: default;
    opacity: 0.7;
  }
  
  .puw2-cards.expanded .rag-mini-card {
    animation: cardSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }
  
  @keyframes cardSlideIn {
    from {
      opacity: 0;
      transform: translateY(20px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  
  .rag-mini-card-link:hover { 
    box-shadow: 0 8px 30px rgba(0,0,0,.08); 
    transform: translateY(-2px);
    border-color: #e8eaed;
  }

  .rag-mini-card-disabled:hover {
    box-shadow: 0 1px 3px rgba(0,0,0,.04);
    transform: translateY(0);
  }
  
  .rag-mini-card-image { 
    width: 100%; 
    aspect-ratio: 4/3; 
    object-fit: cover; 
    background: #fafbfc;
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .rag-mini-card-link:hover .rag-mini-card-image {
    transform: scale(1.03);
  }
  
  .rag-mini-card-placeholder { 
    width: 100%; 
    aspect-ratio: 4/3; 
    display: flex; 
    align-items: center; 
    justify-content: center; 
    background: #fafbfc; 
    font-size: 24px; 
    color: #d1d5db; 
  }
  
  .rag-mini-card-content { 
    padding: 16px; 
    flex: 1; 
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  
  .rag-mini-card-title { 
    font-size: calc(var(--font-size,14px) - 1px); 
    font-weight: 600; 
    margin: 0; 
    color: #18181b; 
    line-height: 1.4; 
    overflow: hidden; 
    text-overflow: ellipsis; 
    display: -webkit-box; 
    -webkit-line-clamp: 2; 
    -webkit-box-orient: vertical; 
  }
  
  .rag-mini-card-subtitle { 
    font-size: calc(var(--font-size,14px) - 2px); 
    margin: 0; 
    color: #71717a; 
    line-height: 1.5; 
    overflow: hidden; 
    text-overflow: ellipsis; 
    display: -webkit-box; 
    -webkit-line-clamp: 2; 
    -webkit-box-orient: vertical; 
  }
  
  .rag-mini-card-footer { 
    padding: 16px; 
    padding-top: 0;
  }
  
  .rag-mini-card-cta { 
    width: 100%; 
    padding: 10px 16px; 
    border: none; 
    border-radius: 8px; 
    background: linear-gradient(135deg, var(--primary,#2563eb) 0%, color-mix(in srgb, var(--primary,#2563eb) 85%, #000) 100%);
    color: #fff; 
    font-weight: 600; 
    font-size: calc(var(--font-size,14px) - 2px); 
    text-decoration: none; 
    display: block; 
    text-align: center; 
    transition: all .25s cubic-bezier(0.4, 0, 0.2, 1); 
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    letter-spacing: 0.2px;
  }

  .rag-mini-card-disabled .rag-mini-card-cta {
    background: #e5e7eb;
    color: #9ca3af;
  }
  
  .rag-mini-card-cta::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 100%);
    opacity: 0;
    transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .rag-mini-card-link:hover .rag-mini-card-cta::before {
    opacity: 1;
  }
  
  .rag-mini-card-link:hover .rag-mini-card-cta { 
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
  }

  /* WhatsApp Product Card Button */
  .rag-mini-card-cta-whatsapp {
    padding: 8px 12px;
    border: none;
    border-radius: 8px;
    background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
    color: #fff;
    font-weight: 600;
    font-size: calc(var(--font-size,14px) - 3px);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    cursor: pointer;
    transition: all .25s cubic-bezier(0.4, 0, 0.2, 1);
    box-sizing: border-box;
    letter-spacing: 0.1px;
    font-family: inherit;
    width: 100%;
    margin-top: 4px;
    white-space: nowrap;
    line-height: 1;
  }

  .rag-mini-card-cta-whatsapp svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }

  .rag-mini-card-cta-whatsapp:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
    background: linear-gradient(135deg, #128c7e 0%, #075e54 100%);
  }

  .rag-mini-card-footer {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  /* Source chips - improved design */
  .puw2-sources { 
    display: flex; 
    flex-wrap: wrap; 
    gap: 8px; 
    margin-top: 8px; 
    padding: 8px 12px;
    background: color-mix(in srgb, var(--primary, #2563eb) 5%, transparent);
    border-radius: calc(var(--radius, 8px) - 2px);
    border-left: 3px solid var(--primary, #2563eb);
  }
  
  .puw2-sources-label {
    font-size: 11px;
    font-weight: 600;
    color: var(--text, #1f2937);
    opacity: 0.7;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-right: 4px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }
  
  .puw2-chip { 
    display: inline-flex; 
    align-items: center; 
    gap: 6px; 
    padding: 6px 12px; 
    border-radius: 999px; 
    background: #fff;
    color: var(--primary, #2563eb); 
    border: 1px solid color-mix(in srgb, var(--primary, #2563eb) 30%, transparent);
    text-decoration: none; 
    font-size: calc(var(--font-size,14px) - 1px);
    font-weight: 500;
    transition: all .2s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    max-width: 92%;
  }
  
  .puw2-chip:hover { 
    background: var(--primary, #2563eb); 
    color: #fff;
    border-color: var(--primary, #2563eb);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(37, 99, 235, 0.25);
  }
  
  .puw2-chip-icon {
    width: 14px;
    height: 14px;
    stroke: currentColor;
    flex-shrink: 0;
  }
  
  .puw2-chip span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .puw2-chip:hover .puw2-chip-icon {
    animation: linkBounce 0.5s ease;
  }
  
  @keyframes linkBounce {
    0%, 100% { transform: rotate(0deg); }
    25% { transform: rotate(-10deg); }
    75% { transform: rotate(10deg); }
  }

  /* Smart Quick Replies overlay (when chat is closed) - DEPRECATED: replaced by expanded pill */
  .rag-smart-quick-replies { position: fixed; display: flex; flex-flow: column; gap: 8px; max-width: 280px; pointer-events: auto; }
  .rag-smart-quick-reply-btn { border: 1px solid var(--primary,#2563eb); background: var(--bg,#fff); color: var(--primary,#2563eb); border-radius: calc(var(--radius,8px) * 2); padding: 8px 16px; cursor: pointer; opacity: 0; transform: translateY(10px); box-shadow: 0 2px 8px rgba(0,0,0,.1); font-weight: 500; font-size: calc(var(--font-size,14px) - 2px); font-family: inherit; }
  .rag-smart-quick-reply-btn:hover { background: var(--primary,#2563eb); color: #fff; }
  
  /* Unified pill: expands from floating button as single element */
  .rag-unified-pill {
    height: 56px;
    display: flex;
    align-items: center;
    background: transparent;
    border: none;
    border-radius: var(--radius, 8px);
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    animation: pillExpandFromButton 0.6s cubic-bezier(0.22, 0.61, 0.36, 1) forwards;
    overflow: visible;
    /* No width set - let max-width animation and content control it */
  }
  
  .rag-unified-pill:hover {
    transform: translateX(-4px);
    box-shadow: 0 6px 16px rgba(0,0,0,0.25);
  }
  
  .rag-unified-pill:focus {
    outline: 2px solid var(--primary,#2563eb);
    outline-offset: 2px;
  }
  
  /* Content area (left part with white background) */
  .rag-unified-pill-content {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    background: var(--bg,#fff);
    padding: 0 28px 0 14px; /* right padding reserves room for the corner X */
    border-radius: var(--radius, 8px);
    margin-right: 0;
    box-shadow: 0 var(--shadow-btn-y, 4px) var(--shadow-btn-blur, 12px) rgba(0,0,0,var(--shadow-btn-alpha,0.18));
    position: relative;
    overflow: hidden;
    opacity: 1; /* Always visible */
    cursor: pointer;
  }
  .rag-unified-pill-content:focus-visible {
    outline: 2px solid var(--primary,#2563eb);
    outline-offset: -2px;
  }
  
  /* Left icon (chat/whatsapp) */
  .rag-unified-pill-icon-left {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: color-mix(in srgb, var(--primary, #2563eb) 10%, transparent);
    border-radius: 50%;
    color: var(--primary,#2563eb);
  }
  
  /* Static CTA text (no rotation) */
  .rag-unified-pill-text {
    flex: 1;
    font-size: calc(var(--font-size,14px) - 1px);
    font-weight: 500;
    color: var(--text,#1f2937);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  /* Right icon button (same as floating button) */
  .rag-unified-pill-icon-right {
    /* The pill now sits next to the real floating button, so the fake
       in-pill launcher is hidden (avoids the duplicate/mismatched button). */
    display: none;
  }
  
  .rag-unified-pill-icon-right svg {
    width: 28px;
    height: 28px;
  }
  
  @keyframes pillExpandFromButton {
    0% { 
      max-width: 56px;
    }
    100% { 
      max-width: 500px; /* Large enough for any text */
    }
  }
  
  @keyframes pillContentFadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  
  /* DEPRECATED: Old expanded pill styles */
  .rag-expanded-pill {
    background: var(--bg,#fff);
    border: 1px solid var(--primary,#2563eb);
    border-radius: calc(var(--radius,8px) * 3);
    padding: 12px 60px 12px 16px;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0,0,0,.15);
    transition: all 0.3s ease;
    animation: pillSlideFromButton 0.4s cubic-bezier(0.34, 1.30, 0.64, 1);
    max-width: 320px;
    min-width: 240px;
  }
  
  .rag-expanded-pill:hover {
    transform: translateX(-2px);
    box-shadow: 0 6px 16px rgba(0,0,0,.2);
    border-color: var(--primary,#2563eb);
    background: color-mix(in srgb, var(--primary, #2563eb) 3%, var(--bg,#fff));
  }
  
  .rag-expanded-pill:focus {
    outline: 2px solid var(--primary,#2563eb);
    outline-offset: 2px;
  }
  
  .rag-expanded-pill-content {
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
  }
  
  .rag-expanded-pill-icon {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: color-mix(in srgb, var(--primary, #2563eb) 10%, transparent);
    border-radius: 50%;
    color: var(--primary,#2563eb);
  }
  
  .rag-expanded-pill-text {
    flex: 1;
    font-size: calc(var(--font-size,14px) - 1px);
    font-weight: 500;
    color: var(--text,#1f2937);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    animation: chipFadeIn 0.3s ease;
  }
  
  .rag-expanded-pill-close {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border: none;
    background: transparent;
    color: #6b7280;
    border-radius: 50%;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    margin-left: 4px;
  }
  
  .rag-expanded-pill-close:hover {
    background: #f3f4f6;
    color: #1f2937;
  }
  
  @keyframes pillSlideFromButton {
    0% { opacity: 0; transform: translateX(100px) scale(0.8); }
    60% { opacity: 1; transform: translateX(-4px) scale(1.02); }
    100% { opacity: 1; transform: translateX(0) scale(1); }
  }
  
  @keyframes chipFadeIn {
    0% { opacity: 0; transform: translateX(10px); }
    100% { opacity: 1; transform: translateX(0); }
  }
  
  /* Close button for smart quick replies - positioned at the top right */
  .rag-smart-quick-reply-close {
    width: 28px;
    height: 28px;
    min-width: 28px;
    border: 1px solid #e5e7eb;
    background: var(--bg,#fff);
    color: #6b7280;
    border-radius: 50%;
    padding: 0;
    cursor: pointer;
    opacity: 0;
    transform: translateY(10px);
    box-shadow: 0 2px 8px rgba(0,0,0,.1);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    order: -1; /* Place at the top */
    margin-left: auto; /* Push to the right */
    margin-bottom: 4px; /* Space between close and chips */
  }
  .rag-smart-quick-reply-close:hover {
    background: #f3f4f6;
    color: #1f2937;
    border-color: #d1d5db;
  }
  .rag-smart-quick-reply-close svg {
    width: 14px;
    height: 14px;
  }

  .rag-smart-whatsapp-btn {
    background: linear-gradient(135deg, #dcf8c6 0%, #e8f5e9 100%) !important;
    border: 1px solid #25d366 !important;
    color: #1f2937 !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rag-smart-whatsapp-btn:hover {
    background: linear-gradient(135deg, #c8f0b8 0%, #d4edd4 100%) !important;
    border-color: #128c7e !important;
    color: #1f2937 !important;
  }

  .rag-smart-whatsapp-btn svg {
    fill: #25d366;
  }
  @keyframes smartReplySlideUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

  /* Watermark */
  .puw2-watermark { 
    padding: 8px var(--spacing,16px); 
    background: #f3f4f6; 
    border-top: 1px solid #e5e7eb;
    text-align: center;
  }
  .puw2-watermark-link { 
    font-size: 11px; 
    color: #9ca3af; 
    text-decoration: none;
    transition: color .2s ease;
    display: inline-block;
  }
  .puw2-watermark-link:hover { 
    color: #00e88d; 
  }
  .puw2-watermark-link:hover strong { 
    color: #00e88d; 
  }
  .puw2-watermark-link strong { 
    font-weight: 600; 
    color: #00644b;
  }

  /* WhatsApp CTA Styles: solo la variante card-cta (la phone-capture e' stata tolta) */
  .puw2-whatsapp-cta {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 12px;
    background: linear-gradient(to top, rgba(255,255,255,0.98) 0%, rgba(255,255,255,0.90) 70%, rgba(255,255,255,0) 100%);
    animation: puw2SlideIn 0.3s ease-out;
    z-index: 10;
    pointer-events: none;
  }

  .puw2-whatsapp-card {
    background: linear-gradient(135deg, #dcf8c6 0%, #e8f5e9 100%);
    border: 2px solid #25d366;
    border-radius: var(--radius, 8px);
    padding: 12px;
    box-shadow: 0 4px 12px rgba(37, 211, 102, 0.15);
    pointer-events: auto;
  }

  .puw2-whatsapp-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .puw2-whatsapp-close {
    background: none;
    border: none;
    color: #666;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s;
  }

  .puw2-whatsapp-close:hover {
    color: #333;
  }

  .puw2-whatsapp-close svg {
    width: 18px;
    height: 18px;
  }

  .puw2-whatsapp-body {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .puw2-whatsapp-button {
    width: 100%;
    padding: 8px 14px;
    background: #25d366;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: calc(var(--font-size, 14px) - 1px);
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;
    font-family: inherit;
    box-sizing: border-box;
  }

  .puw2-whatsapp-button:hover {
    background: #128c7e;
  }

  .puw2-whatsapp-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  /* Card CTA specific styles */
  .puw2-whatsapp-card-cta {
    background: linear-gradient(135deg, #dcf8c6 0%, #e8f5e9 100%);
  }

  .puw2-whatsapp-header-cta {
    align-items: flex-start;
    margin-bottom: 12px;
  }

  .puw2-whatsapp-title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
    flex: 1;
    line-height: 1.3;
  }

  .puw2-whatsapp-subtitle {
    font-size: 13px;
    color: #374151;
    margin: 0 0 16px 0;
    line-height: 1.5;
  }

  .puw2-whatsapp-button-cta {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 16px;
    font-size: var(--font-size, 14px);
  }

  .puw2-whatsapp-button-cta svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }

  .puw2-spinner {
    width: 16px;
    height: 16px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  /* WhatsApp Quick Reply Chip */
  .puw2-quick-replies .puw2-chip-whatsapp {
    background: linear-gradient(135deg, #dcf8c6 0%, #e8f5e9 100%);
    border: 1px solid #25d366;
    color: #1f2937;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .puw2-chip-whatsapp svg {
    width: 16px;
    height: 16px;
    fill: #25d366;
  }

  .puw2-chip-whatsapp:hover {
    background: linear-gradient(135deg, #c8f0b8 0%, #d4edd4 100%);
    border-color: #128c7e;
  }

  /* ---------- Modulo contatti (card kind: contact_form) ---------- */
  /* Non e' una card prodotto: sta nel flusso del messaggio, a piena
     larghezza, senza carosello e senza il "Mostra 1 prodotto". */

  .puw2-contact-form {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin: 8px 0 4px;
    padding: 16px;
    background: var(--bg, #fff);
    border: 1px solid var(--border, #e5e7eb);
    border-radius: var(--radius, 8px);
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  }

  .puw2-contact-title {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--text, #1f2937);
  }

  .puw2-contact-desc {
    margin: -8px 0 0;
    font-size: 13px;
    line-height: 1.5;
    color: var(--text-muted, #6b7280);
  }

  .puw2-contact-field { display: flex; flex-direction: column; gap: 6px; }

  .puw2-contact-label {
    font-size: 12.5px;
    font-weight: 600;
    color: var(--text, #1f2937);
  }

  .puw2-contact-required { color: #dc2626; }

  .puw2-contact-input {
    width: 100%;
    box-sizing: border-box;
    padding: 9px 11px;
    font: inherit;
    font-size: 13.5px;
    color: var(--text, #1f2937);
    background: var(--bg-input, #fff);
    border: 1px solid var(--border, #e5e7eb);
    border-radius: calc(var(--radius, 8px) * 0.75);
    transition: border-color .15s ease, box-shadow .15s ease;
  }

  .puw2-contact-input:focus {
    outline: none;
    border-color: var(--primary, #2563eb);
    /* L'alone segue il colore del widget, non un blu fisso. */
    box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary, #2563eb) 18%, transparent);
  }

  textarea.puw2-contact-input { resize: vertical; min-height: 62px; }

  .puw2-contact-choices { display: flex; flex-wrap: wrap; gap: 8px; }

  .puw2-contact-choice {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 7px 11px;
    font-size: 13px;
    color: var(--text, #1f2937);
    background: var(--bg-input, #fff);
    border: 1px solid var(--border, #e5e7eb);
    border-radius: 999px;
    cursor: pointer;
    transition: border-color .15s ease, background .15s ease;
  }

  .puw2-contact-choice:hover { border-color: var(--primary, #2563eb); }

  .puw2-contact-choice input { margin: 0; accent-color: var(--primary, #2563eb); }

  /* Raggiunto il massimo di scelte le altre si spengono: il limite si vede
     mentre si sceglie, non dopo aver premuto Invia. */
  .puw2-contact-choice.is-blocked { opacity: .45; cursor: not-allowed; }
  .puw2-contact-choice.is-blocked:hover { border-color: var(--border, #e5e7eb); }

  .puw2-contact-consent {
    display: flex;
    align-items: flex-start;
    gap: 9px;
    font-size: 12.5px;
    line-height: 1.5;
    color: var(--text-muted, #6b7280);
    cursor: pointer;
  }

  .puw2-contact-consent input {
    margin: 2px 0 0;
    flex: none;
    accent-color: var(--primary, #2563eb);
  }

  .puw2-contact-consent a { color: var(--primary, #2563eb); }

  .puw2-contact-hint {
    margin: 0;
    font-size: 11.5px;
    color: var(--text-muted, #6b7280);
  }

  .puw2-contact-error { margin: 0; font-size: 12px; color: #dc2626; }

  .puw2-contact-field.has-error .puw2-contact-input { border-color: #dc2626; }

  .puw2-contact-server-errors {
    padding: 9px 11px;
    font-size: 12.5px;
    line-height: 1.5;
    color: #991b1b;
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: calc(var(--radius, 8px) * 0.75);
  }

  .puw2-contact-server-errors p { margin: 0 0 4px; }
  .puw2-contact-server-errors p:last-child { margin-bottom: 0; }

  .puw2-contact-submit {
    padding: 10px 16px;
    font: inherit;
    font-size: 13.5px;
    font-weight: 600;
    color: var(--on-primary, #fff);
    background: var(--bg-button, var(--primary, #2563eb));
    border: none;
    border-radius: calc(var(--radius, 8px) * 0.75);
    cursor: pointer;
    transition: opacity .15s ease;
  }

  .puw2-contact-submit:hover { opacity: .9; }
  .puw2-contact-submit:disabled { opacity: .55; cursor: default; }

  /* Esca antirobot: fuori schermo, mai visibile e mai raggiungibile da
     tastiera. Non display:none, che alcuni robot riconoscono e saltano. */
  .puw2-contact-trap {
    position: absolute !important;
    left: -9999px !important;
    width: 1px; height: 1px;
    overflow: hidden;
  }

  .puw2-contact-form-done { flex-direction: row; align-items: center; gap: 11px; }

  .puw2-contact-done-icon {
    flex: none;
    width: 20px; height: 20px;
    color: var(--primary, #16a34a);
    stroke-width: 2.5;
  }

  .puw2-contact-done-text { margin: 0; font-size: 13.5px; color: var(--text, #1f2937); }

  /* Pulsante sempre disponibile per aprire il modulo a mano. Stesso aspetto
     delle risposte rapide: e' un'uscita a portata di mano, non l'invito
     principale della chat. */
  /* Campo file del modulo contatti */
  .puw2-contact-file-pick {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    font-size: 13px;
    color: var(--text-muted, #6b7280);
    background: var(--bg-input, #fff);
    border: 1px dashed var(--border, #e5e7eb);
    border-radius: calc(var(--radius, 8px) * 0.75);
    cursor: pointer;
    transition: border-color .15s ease, color .15s ease;
  }
  .puw2-contact-file-pick:hover { border-color: var(--primary, #2563eb); color: var(--text, #1f2937); }
  .puw2-contact-file-pick:focus-within {
    border-color: var(--primary, #2563eb);
    box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary, #2563eb) 18%, transparent);
  }
  .puw2-contact-file-pick input { position: absolute; inset: 0; width: 100%; height: 100%; opacity: 0; cursor: pointer; }
  .puw2-contact-file-pick.is-uploading { cursor: progress; color: var(--text, #1f2937); }
  .puw2-contact-file-pick.is-uploading input { cursor: progress; }
  .puw2-contact-file-pick svg, .puw2-contact-file-chosen svg { width: 16px; height: 16px; flex: none; color: var(--primary, #2563eb); }
  .puw2-contact-field.has-error .puw2-contact-file-pick { border-color: #dc2626; }
  .puw2-contact-file-chosen {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    font-size: 13px;
    color: var(--text, #1f2937);
    background: color-mix(in srgb, var(--primary, #2563eb) 6%, var(--bg-input, #fff));
    border: 1px solid var(--border, #e5e7eb);
    border-radius: calc(var(--radius, 8px) * 0.75);
  }
  .puw2-contact-file-name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .puw2-contact-file-size { flex: none; font-size: 12px; color: var(--text-muted, #6b7280); }
  .puw2-contact-file-remove {
    flex: none;
    padding: 2px 4px;
    font: inherit;
    font-size: 12px;
    color: var(--primary, #2563eb);
    background: none;
    border: none;
    cursor: pointer;
  }
  .puw2-contact-file-remove:hover { text-decoration: underline; }

  .puw2-contact-trigger { display: flex; padding: 4px 12px 6px; }
  .puw2-contact-trigger-btn { display: inline-flex; align-items: center; gap: 6px; }
  .puw2-contact-trigger-btn svg { width: 14px; height: 14px; flex: none; }

  /* Passaggio a WhatsApp scelto dal bot: stessa cornice del modulo contatti,
     il messaggio gia' pronto in vista prima del pulsante. */
  .puw2-wa-handoff {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 8px 0 4px;
    padding: 14px 16px;
    background: var(--bg, #fff);
    border: 1px solid var(--border, #e5e7eb);
    border-radius: var(--radius, 8px);
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  }

  .puw2-wa-handoff-label {
    margin: 0;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-muted, #6b7280);
  }

  .puw2-wa-handoff-text {
    margin: 0;
    padding: 8px 10px;
    font-size: 13.5px;
    line-height: 1.5;
    color: var(--text, #1f2937);
    background: #e7f8ee;
    border-radius: calc(var(--radius, 8px) * 0.75);
    white-space: pre-wrap;
  }

  .puw2-wa-handoff-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 16px;
    font-size: 13.5px;
    font-weight: 600;
    color: #fff;
    text-decoration: none;
    /* Verde WhatsApp scuro: sul verde chiaro il bianco non si legge. */
    background: #0f7b6c;
    border-radius: calc(var(--radius, 8px) * 0.75);
    transition: background .15s ease;
  }

  .puw2-wa-handoff-button:hover { background: #0b6358; }
  .puw2-wa-handoff-button svg { width: 18px; height: 18px; flex: none; }

  /* Su iPhone Safari ingrandisce la pagina quando si tocca un campo con il
     testo sotto i 16 px, e per rimetterla a posto bisogna pizzicare lo
     schermo. Nel modulo si scrivono nome, email e telefono: niente zoom. */
  @media (max-width: 768px) {
    .puw2-contact-input { font-size: 16px; }
  }
`;
